<template>
  <Heading
    v-if="!hideTitle"
    :level="2"
    :title="$t('product.show.basicDetails.detailsToRemember')"
    h-class="text-h4 font-medium"
    class="kft-heading--left mt-8 mb-2"
  />

  <NuxtLazyHydrate when-visible>
    <EventImportantDetailsChips
      v-if="eventData"
      :event-data="eventData as EventDescription"
      :is-giftcard="isGiftcard"
    />
  </NuxtLazyHydrate>
  <div
    class="divide-y divide-stone-100"
    itemscope
    itemtype="https://schema.org/FAQPage"
  >
    <div
      v-for="(ok, i) in computedEventData"
      :key="i"
      :data-id="ok.type"
      class="gap-4 py-5 first:pt-0"
      itemprop="mainEntity"
      itemscope
      itemtype="https://schema.org/Question"
    >
      <div class="min-w-0 flex">
        <component
          :is="ok.icon"
          class="mt-0.5 shrink-0"
          width="24"
          height="24"
        />
        <div class="flex flex-col">
          <h3 class="text-lg font-medium ml-4 leading-6" itemprop="name">
            {{ ok.title }}
          </h3>
          <div
            class="mt-5 ml-4 text-stone-700"
            itemprop="acceptedAnswer"
            itemscope
            itemtype="https://schema.org/Answer"
          >
            <div itemprop="text" v-html="ok.description"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconTable from '~/assets/icons/event/note-stroke.svg?component'
import IconPeople from '~/assets/icons/event/event-summary-people.svg?component'
import IconIncluded from '~/assets/icons/event/event-summary-pencil.svg?component'
import { useTitleByCategory } from '~/composables/product/useGetTitleByCategory'
import type { EventDescription } from '~/composables/types/event'

const { t: $t } = useI18n()
const { getTitleByCategory } = useTitleByCategory()

const {
  eventData = {} as EventDescription,
  isGiftcard = false,
  hideTitle = false,
} = defineProps<{
  eventData?: EventDescription
  isGiftcard?: boolean
  hideTitle?: boolean
}>()

const computedEventData = computed(() => {
  return [
    {
      type: 'bring',
      icon: IconTable,
      title: getTitleByCategory('whatToBring', eventData, isGiftcard),
      description: eventGetters.getWhatToBring(eventData),
    },
    {
      type: 'included',
      icon: IconIncluded,
      title: getTitleByCategory('whatIsIncluded', eventData, isGiftcard),
      description: eventGetters.getWhatIsIncluded(eventData),
    },
    {
      type: 'people',
      icon: IconPeople,
      title: getTitleByCategory('teamEventAndPrivate', eventData, isGiftcard),
      description:
        eventGetters.getTeamEventsAndGiftCardsSummary(eventData) ||
        $t('product.show.giftcardIcons.teamEventsAndGiftCardsContent'),
    },
  ]
})
</script>
